import Buefy from 'buefy';
import 'buefy/lib/buefy.min.css';

import '@fortawesome/fontawesome-free/css/all.css';

import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/styles/main.scss';

const isProd = process.env.NODE_ENV === 'production';

Vue.use(VueAnalytics, {
  id() {
    return 'UA-124182843-1';
  },
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
});
Vue.use(Buefy);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
